import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=4a7a624c&scoped=true&"
var script = {}
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&id=4a7a624c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7a624c",
  null
  
)

export default component.exports